export default __webpack_public_path__ + "3628df75071375ff54477dadf388519e.png";